import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiContact } from 'modules/api';
import { ContactFormData } from 'modules/types/ContactFormData';

export const sendContactMessage = createAsyncThunk(
  'contact/sendMessage',
  async (contactForm: ContactFormData, { rejectWithValue }) => {
    try {
      const response = await ApiContact.sendContactMessage(contactForm);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
